import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";
import "./Blogs.scss";

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const containerRef = useRef(null);

  useEffect(() => {
    const query = '*[_type == "blog"] | order(publishedAt desc)[0...5]';
    client.fetch(query).then((data) => {
      setBlogs(data);
    });
  }, []);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  return (
    <div className="app__blogs">
      <h2 className="head-text">
        Latest <span>Blogs</span>
      </h2>

      <div className="app__blogs-container">
        <button className="scroll-button left" onClick={scrollLeft}>
          <FaArrowLeft />
        </button>

        <div className="app__blogs-scroll" ref={containerRef}>
          {blogs.map((blog, index) => (
            <div className="app__blog-item" key={blog.slug.current + index}>
              <Link to={`/blogs/${blog.slug.current}`} className="blog-link">
                <img src={urlFor(blog.mainImage)} alt={blog.title} />
                <h3 className="bold-text">{blog.title}</h3>
                <p className="p-text">{blog.description}</p>
                <p
                  className="p-text"
                  style={{ marginTop: 10, color: "#6b7688" }}
                >
                  Published on:{" "}
                  {new Date(blog.publishedAt).toLocaleDateString()}
                </p>
              </Link>
            </div>
          ))}
        </div>

        <button className="scroll-button right" onClick={scrollRight}>
          <FaArrowRight />
        </button>
      </div>
      {/* Show All Blogs Button */}
      <div className="show-all-button">
        <Link to="/blogs" className="btn">
          Show All Blogs
        </Link>
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Blogs, "app__blogs"),
  "blogs",
  "app__whitebg"
);
